<template>
  <v-data-table
    :headers="headers"
    :items="dues"
    hide-actions
    class="agreement-dues-table w-100"
    no-data-text="No hay cuotas registradas">
    <template slot="headers" slot-scope="props">
      <th
        v-for="(header, index) in props.headers"
        :key="`header-${index}`"
        :class="header.class">
        {{ header.text }}
      </th>
    </template>
    <template slot="items" slot-scope="props">
      <tr>
        <td class="text-xs-left">{{ props.index + 1 }}</td>
        <td class="text-xs-left">{{ formatDate(props.item.due_date) }}</td>
        <td class="text-xs-right">{{ formatCurrency(props.item.amount) }}</td>
        <td class="text-xs-right">{{ formatCurrency(props.item.paid_balance) }}</td>
        <td class="text-xs-right">
          <agreement-status-badge
            v-if="props.item.status"
            :name="props.item.status.name"
            type="due" />
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import AgreementStatusBadge from './AgreementStatusBadge';

export default {
  components: {
    AgreementStatusBadge,
  },
  props: {
    dues: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: 'MXN',
    },
  },
  data() {
    return {
      headers: [
        { text: '#', class: 'text-xs-left', sortable: false },
        { text: 'Fecha', class: 'text-xs-left', sortable: false },
        { text: 'Monto', class: 'text-xs-right', sortable: false },
        { text: 'Pagado', class: 'text-xs-right', sortable: false },
        { text: 'Estado', class: 'text-xs-right', sortable: false },
      ],
    };
  },
  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: this.currency,
      }).format(amount || 0);
    },
    formatDate(dateStr) {
      if (!dateStr) {
        return '-';
      }

      return new Date(`${dateStr}T00:00:00`).toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
  },
};
</script>

<style scoped>
.agreement-dues-table >>> .table thead tr th {
  font-size: 12px;
  font-weight: 600;
  color: #444441;
}

.agreement-dues-table >>> .table tbody tr td {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/agreements/AgreementDuesTable.vue